function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.714 1C.768 1 0 1.784 0 2.75v5.833c0 .967.768 1.75 1.714 1.75h8c.947 0 1.715-.783 1.715-1.75V2.75c0-.966-.768-1.75-1.714-1.75h-8zM4.67 13.833c.235.68.87 1.167 1.616 1.167h3.43C13.184 15 16 12.127 16 8.583V7.417c0-.762-.477-1.41-1.143-1.65v2.816c0 2.9-2.302 5.25-5.143 5.25H4.67zm-.67-1.166A1.718 1.718 0 012.384 11.5h7.331c1.578 0 2.857-1.306 2.857-2.917v-5.15c.666.24 1.143.888 1.143 1.65v3.5c0 2.255-1.79 4.084-4 4.084H4z",
  fill: "#8F90A6"
});

function SvgTaskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTaskIcon;